(function () {
  'use strict';

  let observer = null;

  function reveal(el) {
    var duration = el.getAttribute('data-wow-duration');
    var delay = el.getAttribute('data-wow-delay');
    if (duration) el.style.animationDuration = duration;
    if (delay) el.style.animationDelay = delay;
    el.classList.add('is-visible');
  }

  function observe(elements) {
    if (!elements.length) return;

    if (!observer) {
      elements.forEach(reveal);
      return;
    }

    elements.forEach(function (el) {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
  }

  function init() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    }

    observe(document.querySelectorAll('.wow'));

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        var added = [];
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.classList && node.classList.contains('wow')) {
              added.push(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('.wow').forEach(function (el) { added.push(el); });
            }
          });
        });
        if (added.length) observe(added);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
